// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".notification-item-title{font-size:14px;font-weight:700}.notification-item-desc{font-size:10px}", "",{"version":3,"sources":["/app/src/components/common/notification/NotificationCard.vue"],"names":[],"mappings":"AAEE,yBACE,cAAA,CACA,eADJ,CAGE,wBACE,cADJ","file":"NotificationCard.vue","sourcesContent":["\n.notification-item {\n  &-title {\n    font-size: 14px;\n    font-weight: bold;\n  }\n  &-desc {\n    font-size: 10px;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
